<template>
    <div class="v-editorbar" v-if="pres">
		<button
		@click="save()"
		:title="$t('save Presentation')"
		class="st-btn st-btn--small st-btn--icon"
		:class="{'st-btn--primary': pres.changed }"><i class="fa fa-floppy-o" aria-hidden="true"></i></button>

        <a
        v-if="urls.view"
        :href="viewurl"
        :title="$t('view Presentation')"
		target="_blank" rel="noopener" class="st-btn st-btn--small st-btn--icon"><i class="fa fa-play" aria-hidden="true"></i></a>

        <button
        v-if="urls.view"
        :title="$t('copy Presentationlink')"
        @click="copy"
        class="st-btn st-btn--small st-btn--icon"><i class="fa fa-link" aria-hidden="true"></i></button>

		<router-link
		v-if="pres.id"
		:title="$t('edit Settings')"
		:to="{ name: 'presentation-settings', params: {pid: pres.id} }"
		class="st-btn st-btn--small st-btn--icon"><i class="fa fa-cog" aria-hidden="true"></i></router-link>
    </div>
</template>


<script>
import help_general from '@/helpers/general';
export default {
	name: 'v-editorbar',
	data(){
		return {
			saveSub: false,
		}
	},
	computed: {
		pres(){
			return this.$store.getters.presentation;
		},
		viewurl(){
			if(this.$route.params && this.$route.params.chartid && this.$route.params.chartid > 0) {
				const chart = this.$store.getters.getChartById(this.$route.params.chartid);
				return (chart ? this.urls.view + '/#/' + chart.template + chart.id : this.urls.view);
			}
			return this.urls.view;
		},
	},
	props: {
		urls: {
			type: Object,
			default: function(){
				return {};
			}
		},
		token: {
			type: String,
			default: ''
		}
	},
	mounted(){
		if(window.evn) this.saveSub = window.evn.subscribe('save', this.save);
	},
	destroyed(){
		if(window.evn && this.saveSub) {
			this.saveSub.remove();
			this.saveSub = false;
		}
	},
	methods: {
		save(){
			this.$store.commit('RESET_ACTIVE_FIELD');
			this.$emit('save');
		},
		copy(){
			help_general.copyToClipboard(this.urls.view);
		}
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/v-editorbar.vue